import { useState } from 'react';
import { faqs } from '@/mocks/chaoyang';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-[#fff7ec] py-10 md:py-14">
      <div className="chigua-container max-w-[900px]">
        <div className="text-center pb-6">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-teal-500/10 px-3 py-1 text-xs font-bold text-teal-700 ring-1 ring-teal-500/20">
            <i className="ri-question-line text-sm"></i>
            帮助中心
          </span>
          <h2 className="mt-3 text-2xl font-black tracking-tight text-stone-900 md:text-3xl">常见问题</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-stone-600">关于投稿、核实与转载的疑问，这里都有答案。</p>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className={`overflow-hidden rounded-2xl bg-white ring-1 transition-colors ${isOpen ? 'ring-orange-500/30' : 'ring-black/5'}`}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer md:px-6"
                  aria-expanded={isOpen}
                >
                  <span className={`text-[15px] font-bold md:text-base ${isOpen ? 'text-orange-700' : 'text-stone-900'}`}>
                    <i className={`ri-question-answer-line mr-2 ${isOpen ? 'text-orange-500' : 'text-stone-300'}`}></i>
                    {f.q}
                  </span>
                  <i className={`ri-arrow-down-s-line shrink-0 text-xl text-stone-400 transition-transform duration-300 ${isOpen ? 'rotate-180 text-orange-500' : ''}`}></i>
                </button>
                {isOpen && (
                  <div className="border-t border-black/5 px-5 py-4 md:px-6">
                    <p className="text-sm leading-relaxed text-stone-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}